/**
 * Stone Investment Property Contact Card
 *
 * Stone-themed wrapper for the core PropertyContactCard component.
 * Applies square corners and Stone typography.
 */

'use client';

import { PropertyContactCard, type PropertyContactCardProps } from '@/components/properties';

export type { PropertyContactCardProps as StonePropertyContactCardProps };

export function StonePropertyContactCard(props: PropertyContactCardProps) {
  return (
    <div
      className="
        relative
        font-['Montserrat',-apple-system,BlinkMacSystemFont,'Segoe_UI',sans-serif]
        [&_h2]:font-['Cormorant_Garamond','Georgia',serif]
        [&_h3]:font-['Cormorant_Garamond','Georgia',serif]
        **:rounded-none
      "
    >
      <PropertyContactCard {...props} className="" />
    </div>
  );
}
